import React, { useEffect, useState } from 'react'

import { useLocation } from 'react-router-dom';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { Grid, GridColumn } from '@progress/kendo-react-grid';

import { getHeytelHashbahaProcessData } from '../../server/ServerFunc';
import AppFooter from '../AppFooter';
import AppHeaderGlobal from '../AppHeaderGlobal';

const ProcessHeytelInfo = ({ isSeparate }) => {
  const [processHeytelTitle, setProcessHeytelTitle] = useState("");
  const [processHeytelList, setProcessHeytelList] = useState([]);

  const search = useLocation().search;

  const titles = {
    "stepCodeText": "שלב",
    "planDateStr": "מועד מתוכנן",
    "execDateStr": "מועד ביצוע",
    "stepStatusText": "סטטוס",
    "hearot": "הערות",
    "total": "מידע נוסף"
  }

  useEffect(() => {
    const tikNumURL = new URLSearchParams(search).get("TikNum");
    getHeytelProcessContent(tikNumURL);
  }, []);

  const getHeytelProcessContent = async (tikNum) => {
    let processesList = [];
    processesList = await getHeytelHashbahaProcessData(tikNum);
    if(processesList.length > 0) {
      let processTitle = processesList[0].processText;
      setProcessHeytelTitle(processTitle);
      setProcessHeytelList(processesList);
    } else {
      setProcessHeytelList([]);
    }
  }

  const LabeledDataItem = (label, value, field) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
      <div className="value">{value}</div>
    </div>
	}

	const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field], props.field)}
		</td>
	}

  return (
    <>
			{ isSeparate && <AppHeaderGlobal /> }
			{
        <div className="container my-3 my-lg-5">
          <PanelBar >
            <PanelBarItem title={processHeytelTitle} expanded={true}>
              <Grid
                data={processHeytelList}
              >
                <GridColumn field="stepCodeText" title={titles.stepCodeText} cell={LabeledCell} />
                <GridColumn field="planDateStr" title={titles.planDateStr} cell={LabeledCell} />
                <GridColumn field="execDateStr" title={titles.execDateStr} cell={LabeledCell} />
                <GridColumn field="stepStatusText" title={titles.stepStatusText} cell={LabeledCell} />
                <GridColumn field="hearot" title={titles.hearot} cell={LabeledCell} />
                <GridColumn field="total" title={titles.total} cell={LabeledCell} />
              </Grid>
            </PanelBarItem>
          </PanelBar>
        </div>
			}
			{ isSeparate && <AppFooter /> }
		</>
  )
}

export default ProcessHeytelInfo